import { Badge } from '../badge/badge'
import { Icon } from '../icon/icon'
import { cn } from '../../lib/utils'

export interface DeltaBadgeProps {
  variant: 'ghost' | 'fill' | 'text'
  size: 'sm' | 'md' | 'lg'
  value: number
}

export function DeltaBadge({
  variant = 'ghost',
  size = 'md',
  value = 0,
}: DeltaBadgeProps) {
  const variantList: Record<
    'ghost' | 'fill' | 'text',
    'solid' | 'liquid' | 'text'
  > = {
    ghost: 'liquid',
    fill: 'solid',
    text: 'text',
  }
  return (
    <Badge
      size={size}
      variant={variantList[variant]}
      color={value === 0 ? 'neutral' : value < 0 ? 'negative' : 'positive'}
    >
      <span className='ltr px-2xs'>%</span>
      <span className='ltr'>
        {value > 0 ? '+' : ''}
        {Math.floor(value * 100) / 100}
      </span>
      {value !== 0 && (
        <Icon
          name='TriangleDown'
          size='xs'
          className={cn(value < 0 ? '' : 'rotate-180')}
          color={
            value < 0
              ? 'fill-negative-surface-100'
              : 'fill-positive-surface-100'
          }
        />
      )}
    </Badge>
  )
}
